module.exports = __webpack_public_path__ + "static/media/1.1.1e4f95a7.png";